import { CampaignForm } from '@/components/campaigns/CampaignForm'
import { PageHeader } from '@/components/editorial/PageHeader'
import {
	buildCreateCampaignInput,
	EMPTY_CAMPAIGN_FORM_VALUES,
	toComboboxOptions,
} from '@/pages/Campaigns/form/form-model'
import { UnsavedChangesDialog } from '@/pages/Campaigns/form/UnsavedChangesDialog'
import { useCampaignFormContainer } from '@/pages/Campaigns/form/useCampaignFormContainer'
import { useCampaignFormState } from '@/pages/Campaigns/form/useCampaignFormState'
import { useUnsavedNavigationGuard } from '@/pages/Campaigns/form/useUnsavedNavigationGuard'

/** New Campaign — hosts the shared form. On success navigates to the created Campaign's detail. */
export function NewCampaignPage() {
	const formContainer = useCampaignFormContainer()
	const form = useCampaignFormState(EMPTY_CAMPAIGN_FORM_VALUES)
	const guard = useUnsavedNavigationGuard(form.isDirty)

	function handleSubmit() {
		if (!form.validate()) return
		formContainer.createMutation.mutate(buildCreateCampaignInput(form.values), {
			onSuccess: (created) => guard.navigateAfterSave(`/campaigns/${created.campaignId}`),
		})
	}

	return (
		<div>
			<PageHeader eyebrow="Campaigns" title="New Campaign" />
			<CampaignForm
				values={form.values}
				fieldErrors={form.fieldErrors}
				isDirty={form.isDirty}
				isPending={formContainer.createMutation.isPending}
				generalError={formContainer.createMutation.isError ? 'Something went wrong saving this Campaign.' : undefined}
				isSuccess={formContainer.createMutation.isSuccess}
				objectiveOptions={toComboboxOptions(formContainer.objective)}
				geographyOptions={toComboboxOptions(formContainer.geography)}
				brandOptions={toComboboxOptions(formContainer.brand)}
				productOptions={toComboboxOptions(formContainer.product)}
				onFieldChange={form.onFieldChange}
				onSubmit={handleSubmit}
				onCancel={() => guard.onCancel('/campaigns')}
			/>
			<UnsavedChangesDialog
				isOpen={guard.isWarningOpen}
				onDiscard={guard.onDiscard}
				onKeepEditing={guard.onKeepEditing}
			/>
		</div>
	)
}
